import { gabc_det_elements_from_notes } from '../score_parsing/glyphs_parser';
import { GregorioElement, GregorioSyllable } from './GregorioSyllable';
import { Lexer } from 'chevrotain';
import { LexerFactory } from '../parsers/compounded/CompoundedLexer';
import { CompoundedInterpreterFactory, interpreteScore } from '../parsers/compounded/CompoundedInterpreter';
import { CompoundedParser } from '../parsers/compounded/CompoundedParser';
import { ChantContext } from '../ChantContext';
import { LexingError } from '../errors/LexingError';
import { ParsingError } from '../errors/ParsingError';
import {
  from_compounded_to_separated_cross_check,
} from '../parsers/converter/wrappers';
import { GregorioMetadata } from './GregorioMetadata';
import { LOWEST_PITCH } from '../constants';
import {
  gregoriotex_compute_positioning,
} from '../../gregorio-chant-svg-renderer/episemas/compute_note_positioning';
import { GregorioSegment } from './GregorioSegment';
import { gabc_determine_punctum_inclinatum_orientation } from '../utils/gabc_determine_punctum_inclinatum_orientation';
import { flattenDeep } from 'lodash';
import { GYPH_MESURING_DUMP } from '../../gregorio-chant-svg-renderer/GlyphMeasurer';

export class GregorioScore {
  syllables: GregorioSyllable[] = [];

  get lexerErrors() {
    return this._lexerErrors;
  }

  private _lexerErrors: LexingError[] = [];
  private _parserErrors: ParsingError[] = [];

  private _lexer: Lexer;
  private _parser: CompoundedParser;
  private _interpreter: any;
  private readonly _context: ChantContext;
  private _metadata: GregorioMetadata;
  get metadata(): GregorioMetadata {
    return this._metadata;
  }

  private _crossCheck = false;
  private _text?: string;
  private _separated?: {
    lyrics: string,
    gabc: string,
    nabc?: string,
  };

  get crossCheck(): boolean {
    return this._crossCheck;
  }

  get text(): string | undefined {
    return this._text;
  }

  get separated(): {
    lyrics: string,
    gabc: string,
    nabc?: string,
  } | undefined {
    return this._separated;
  }


  get context(): ChantContext {
    return this._context;
  }

  staff_lines: number;
  highest_pitch: number;
  high_ledger_line_pitch: number;
  virgula_far_pitch: number;

  constructor(settings: ChantContext) {
    this._context = settings;
    this._metadata = new GregorioMetadata(undefined);
    const lexerResult = LexerFactory(settings);
    this._lexer = lexerResult.lexer;
    this._parser = new CompoundedParser(this._context, lexerResult.pipes);
    this._interpreter = CompoundedInterpreterFactory(this._parser);

    const staff_lines = 4;
    this.staff_lines = staff_lines;
    this.highest_pitch = LOWEST_PITCH + 4 + (2 * staff_lines);
    this.high_ledger_line_pitch = this.highest_pitch - 1;
    this.virgula_far_pitch = this.highest_pitch - 6;
  }

  // todo
  public validate(): {
    success: boolean,
    errors: string[],
  } {
    for (const syllable of this.syllables) {
      // debugger;
    }

    return {
      success: true,
      errors: [],
    };
  }

  public interprete(text: string): {
    lexErrors: LexingError[],
    parseErrors: ParsingError[],
    lexResult: any[],
  } {
    this._text = text;
    const result = interpreteScore(text, this._lexer, this._parser, this._interpreter);
    [this._separated, this._crossCheck] = from_compounded_to_separated_cross_check(result.gnabc);
    this.syllables = result.syllables;
    this._lexerErrors = result.lexErrors;
    this._parserErrors = result.parseErrors;
    this._metadata = result.metadata;

    return {
      lexResult: result.lexResult,
      lexErrors: result.lexErrors,
      parseErrors: result.parseErrors,
    };
  }

  public determineElements() {
    this.processSegments((segment) => {
      segment.elements = gabc_det_elements_from_notes(segment.gabcNotations, this);
    });

    // gregorio magic for punctun inclinatum
    gabc_determine_punctum_inclinatum_orientation(this);

    // basically hepisemas
    this.processSegments((segment) => {
      return gregoriotex_compute_positioning(segment.elements, this);
    });
  }

  processSegments(callback: (segment: GregorioSegment) => void) {
    for (const syllable of this.syllables) {
      for (const segment of syllable.segments) {
        callback(segment);
      }
    }
  }

  public getDescription() {
    // return this.syllables.map(s => `${s.text}`).join('\n');
  }

  public dump(): {
    syllables: string[],
    sylPositions: { [key: string]: number[] },
    glyphMeasuring: any[],
  } {
    const syllables = this.syllables.map((s) => s.textSpans.map(t => t.text).join(''));
    const sylPositions = syllables.reduce((acc, s, index) => {
      if (acc[s]) {
        acc[s].push(index);
      } else {
        acc[s] = [index];
      }
      return acc;
    }, {} as { [key: string]: number[] });

    return {
      syllables,
      sylPositions,
      glyphMeasuring: GYPH_MESURING_DUMP,
    };
  }

  get elements(): GregorioElement[] {
    return flattenDeep(this.syllables.map(s => s.segments.map(seg => seg.elements)));
  }
}
